import { AppDomain, MediaApiPath } from '../Consts'
import { MediaItemData } from '../models/mediaItemData'

export const getMediaItems = async (): Promise<MediaItemData[]> => {
  const mediaApiUrl = `https://${AppDomain}/${MediaApiPath}`
  const res = await fetch(mediaApiUrl)
  if (res.ok) {
    const mediaItems = await res.json()
    return mediaItems as MediaItemData[]
  } else {
    throw new Error('Failed to fetch MediaItems')
  }
}
